export default __webpack_public_path__ + "static/SFMono-Regular-e36fa5257c93fc7711eae342068f9eda.woff";